import styled from 'styled-components';
import * as Styles from '../../utils/styleUtils'; 

export const StyledButton = styled.button`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  cursor: grab;

  padding: ${({ renderMode }) => (renderMode === 'mobile' ? '5px 10px' : '0')};
  ${Styles.FontStyles}
  ${Styles.BorderStyles}

  background: ${({ styleProps }) => {
    const startColor = styleProps?.backgroundColor || '#eeeeee';
    const endColor = styleProps?.advancedBgGradientColor;

    if (!endColor || startColor === endColor) {
      return startColor;
    }
    return `linear-gradient(to bottom, ${startColor}, ${endColor})`;
  }};
`;